import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import format from 'date-fns/format'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getCurrentDate } from 'reducks/calendar/selectors'

const MonthlyLabel: FC = () => {
  const currentDate = useSelector((state: State) => getCurrentDate(state))

  return <p className={styles.label__monthly}>{format(currentDate, 'yyyy年M月')}</p>
}

export default MonthlyLabel
